import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class CategoryService {
  constructor(private http: HttpClient) {}

  public getCategoryTemplates() {
    return this.http
      .get(environment.apiUrl + 'api/ext-item-category/category-templates')
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public applyTemplate(templateId, storeId) {
    return this.http
      .post(
        environment.apiUrl +
          'api/ext-item-category/apply-category-template/' +
          templateId +
          '/' +
          storeId,
        {}
      )
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Get all categories
  public getAllCategories(pagination, sort) {
    const sortString = '&sort=' + sort;

    let paginationString = '';
    paginationString += '?size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    return this.http
      .get(environment.apiUrl + 'api/ext-item-category' + paginationString + sortString, {
        observe: 'response',
      })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  // Get all categories with no pagination (for lists and dropdowns)
  public getAllCategoriesNoPagination() {
    let paginationString = '';
    paginationString += '?size=' + 10000;
    paginationString += '&page=' + 0;
    return this.http
      .get(environment.apiUrl + 'api/ext-item-category' + paginationString)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Get Categorys by Store Id
  public getItemCategoriesByStoreId(id) {
    let paginationString = '';
    paginationString += '?size=' + 10000;
    paginationString += '&page=' + 0;

    const sortString = '&sort=description,asc';

    return this.http
      .get(
        environment.apiUrl + 'api/ext-item-category/by-store/' + id + paginationString + sortString
      )
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Create Category
  public createCategory(obj) {
    const body = {
      name: obj.name,
      description: obj.description,
      enabled: true,
      parentItemCategoryId: obj.parentItemCategoryId,
      storeId: obj.storeId,
    };

    return this.http
      .post(environment.apiUrl + 'api/ext-item-category', body)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Create Category
  public deleteCategory(id) {
    return this.http
      .delete(environment.apiUrl + 'api/ext-item-category/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Edit Category
  public editCategory(obj) {
    return this.http
      .put(environment.apiUrl + 'api/ext-item-category', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // HANDLE DATA
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      headers: headers,
      body: body,
    };
    return data;
  }

  private handleError(error: any) {
    return Observable.throw(new HttpErrorResponse(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/category.service.ts